import {GlobalDictType} from '../global/global.types';
import {VapeType}       from './vape.types';

export const VapeTypesDict: GlobalDictType<VapeType> = {
	cbd        : {
		name   : 'CBD',
		colorTw: 'cyan',
		type   : 'cbd',
		icon   : 'leaf'
	},
	cbn        : {
		name   : 'CBN',
		colorTw: 'blue',
		type   : 'cbn',
		icon   : 'leaf'
	},
	concentrate: {
		name   : 'Concentrate',
		colorTw: 'teal',
		type   : 'concentrate',
		icon   : 'leaf'
	},
	hybrid     : {
		name   : 'Hybrid',
		colorTw: 'lime',
		type   : 'hybrid',
		icon   : 'leaf'
	},
	indica     : {
		name   : 'Indica',
		colorTw: 'emerald',
		type   : 'indica',
		icon   : 'leaf'
	},
	sativa     : {
		name   : 'Sativa',
		colorTw: 'green',
		type   : 'sativa',
		icon   : 'leaf'
	}
};
